import { Activity } from 'react';

import { useAppSelector } from '@/store/hooks';
import { selectFirstSessionUuid } from '@/store/slices/project/selectors';
import useSpeakersForSession from '@/utils/speakers/use-speakers-for-session';
import Button from '@ui/buttons/button/button';
import useCastAndCrewLayoutType from '../helpers/use-cast-and-crew-layout-type';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Container from '@ui/container/container';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import Text from '@ui/text/text/text';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import getThemeColorsCssMixVariable from '@/utils/colors/get-theme-color-css-mix-variable';
import { useCastAndCrewContext } from '../cast-and-crew-context/use-cast-and-crew-context';

const CastHeaderActions = () => {
  const sessionUuid = useAppSelector(selectFirstSessionUuid);
  const speakers = useSpeakersForSession({ sessionUuid });

  const { dispatch: contextDispatch } = useCastAndCrewContext();

  const { handleViewChange, layout } = useCastAndCrewLayoutType();

  const getIconColor = (active: boolean) => {
    if (active) {
      return 'var(--global-ico-text-1)';
    }
    return 'var(--global-ico-text-3)';
  };

  if (!speakers.length) return null;
  return (
    <div className="flex ai-center gap-8">
      <Activity mode={layout === 'list' || (layout === 'grid' && speakers.length >= 4) ? 'visible' : 'hidden'}>
        <Button
          backgroundColor={getThemeColorCSSVariable()}
          hoverBackgroundColor={getThemeColorsCssMixVariable()}
          designSize="small"
          onClick={() => {
            contextDispatch({ type: 'TOGGLE_ADD_CAST_AND_CREW_OPEN', payload: true });
          }}
        >
          <Text className="L2 flex ai-center gap-8" color={getThemeColorContrastCSSVariable()}>
            <Icon name={ICONS.ADD} size={12} /> <span>Add</span>
          </Text>
        </Button>
      </Activity>

      <Button
        clear
        borderRadius="100px"
        onClick={handleViewChange}
        backgroundColor="var(--local-switch-bg)"
        hoverOpacity={0.8}
        className="flex ai-center jc-space-evenly gap-4"
        designSize="small"
        padding="2px"
      >
        <Container
          background={layout === 'grid' ? 'var(--local-switch-active)' : undefined}
          className="square-28 radius-full flex-column ai-center jc-center"
        >
          <Icon name={ICONS.LAYOUT_GRID_4} size={12} color={getIconColor(layout === 'grid')} />
        </Container>
        <Container
          background={layout === 'list' ? 'var(--local-switch-active)' : undefined}
          className="square-28 radius-full flex-column ai-center jc-center"
        >
          <Icon name={ICONS.LAYOUT_LIST_ODD_EVEN} size={12} color={getIconColor(layout === 'list')} />
        </Container>
      </Button>
    </div>
  );
};

export default CastHeaderActions;
